export const BASE_URL = "https://mybizapps.in/nodeapp";
export const IMG_URL = "https://mybizapps.in/uploads";
// export const BASE_URL = "http://localhost:8081/nodeapp"
